const $j = (typeof window !== 'undefined' && window.$j) || (() => {});
const scrolledtop = window.scrolledtop ?? 250;
const _sps = window._sps ?? 100;

export function nav() {
    let fadetime = 250;
    $j('#nav li:not(.blank) a').click(function (e) {
        e.preventDefault();
        const el = $j(this);
        const goLink = el.attr('href');
        if (el.parent().hasClass('menu-item-has-children') && $j('body.oc-open').length) {
            if (el.parent().hasClass('open')) {
                el.find('span.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                el.next('ul').stop(true, false).slideUp(500, 'easeInOutExpo');
            } else {
                el.find('span.fa-plus').addClass('fa-minus').removeClass('fa-plus');
                el.next('ul').stop(true, false).slideDown(500, 'easeInOutExpo');
                $j('li.open a').next('ul').stop(true, false).slideUp(500, 'easeInOutExpo');
                $j('li.open').find('span.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                $j('li.open').removeClass('open');
            }
            el.parent().toggleClass('open');
        } else {
            $j('#nav li.current-menu-item').removeClass('current-menu-item');
            el.parent().addClass('current-menu-item');
            el.addClass('active');
            $j('div.loader, div.home-loader').fadeIn(150);
            fadetime = 250;
            if (!!$j('body.oc-open').length) {
                $j('#site-overlay').fadeOut(100);
                $j('body.oc-open').removeClass('oc-open');
                $j('body.home video').hide();
                fadetime = 360;
            }
            setTimeout(() => (document.location.href = goLink), fadetime);
        }
    });
    $j('li.menu-item-has-children ul>li>a').append('<span class="fa fa-caret-right ddarrow mobile-hide"></span>');
    $j('li.current_page_parent>a').find('span.fa-plus').addClass('fa-minus').removeClass('fa-plus');
    $j('li.current_page_parent').addClass('open');
    $j('li.current_page_parent a').next('ul').slideDown(10);
    $j('.scrolltop').click(() => {
        window.scrollToTop();
        return false;
    });
    $j('.aa').anchorAnimate();
}

($j.fn ??= {}).anchorAnimate = function () {
    return this.each(function (_i, caller) {
        $j(caller).click(function (e) {
            e.preventDefault();
            const elementClick = $j(caller).attr('href');
            const destination = $j(elementClick).offset().top || 0;
            $j('html:not(:animated),body:not(:animated)').animate({ scrollTop: destination }, 1200, 'easeInOutExpo', function () {
                window.location.hash = elementClick;
                $j(caller).parent().parent().find('.active').removeClass('active');
                $j(caller).parent().addClass('active');
            });
            return false;
        });
    });
};

(function (_win, $) {
    const $jq = $;
    $jq(function () {
        let ripplecover;
        const doc = $jq(document);
        doc.on('click', '.card h2 a ', function () {
            $jq('body').addClass('rippling');
            clearTimeout(ripplecover);
            ripplecover = setTimeout(() => $jq('body').removeClass('rippling'), 2000);
        });
        doc.on('click', '.btn, .ripple, .full-nav a, #nav a, .card h2>a', function (event) {
            const $div = $jq('<span class="ripple" />');
            const btnOffset = $jq(this).offset();
            const xPos = event.pageX - btnOffset.left;
            const yPos = event.pageY - btnOffset.top;
            $div.addClass('ripple-effect');
            const $ripple = $jq('.ripple-effect');
            const el = $jq(this);
            $ripple.css('height', el.height());
            $ripple.css('width', el.height());
            $div.css({ top: yPos - $ripple.height() / 2, left: xPos - $ripple.width() / 2, background: el.data('ripple-color') });
            $div.appendTo($jq(this));
            window.setTimeout(() => $div.remove?.(), 1400);
        });
    });
})(window, $j);

function scroller() {
    const w = $j;
    const scrolltop = w(window).scrollTop();
    if (scrolltop > scrolledtop) {
        w('body').addClass('scrolled');
        w('.scrolltop:hidden').stop(true, true).fadeIn();
        w('.scrolltop').addClass('show');
    } else {
        w('body').removeClass('scrolled');
        w('.scrolltop').stop(true, true).fadeOut();
        w('.scrolltop').removeClass('show');
    }
}

$j(window).on('scroll', function () {
    clearTimeout(window.scrollerfn);
    window.scrollerfn = setTimeout(scroller, _sps);
});
